import { render, staticRenderFns } from "./AirportItem.vue?vue&type=template&id=11ab2ca5&scoped=true&"
import script from "./AirportItem.vue?vue&type=script&lang=js&"
export * from "./AirportItem.vue?vue&type=script&lang=js&"
import style0 from "./AirportItem.vue?vue&type=style&index=0&id=11ab2ca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab2ca5",
  null
  
)

export default component.exports